import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import PlayerForm from "../components/PlayerForm";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";

export default function PlayerAdd({ teamId }: { teamId: number }) {

    const savePlayer = (data: any) => {
        const requester = new Requester();

        requester.post(requester.getUrl(`api/players`), data).then((response) => {
            router.visit(`/admin/teams`);
        }).catch((error) => {
            alert("Error adding player: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Add Player" />
            <ContentWrapper>
                <PlayerForm onSubmit={savePlayer} teamId={teamId} />
            </ContentWrapper>
        </App >
    )
}